export default __webpack_public_path__ + "static/media/480_dummy2016-reiseblog01-mobile-de.910c9b4c.png";